module.exports = "\n<menu-layout class=\"tutorial-page\" data-title=\"{{'TUTORIAL' | translate}}\">\n\n\t<div ng-bind-html=\"tutorial.content\"></div>\n\n</menu-layout>\n"


//////////////////
// WEBPACK FOOTER
// ./src/page/tutorial/tutorial.html
// module id = 532
// module chunks = 0